import './styles.scss'
import { useState } from 'react'

interface Props {
  question: string
  response: string
  active: boolean
}

export default function QuestionAnswer({ question, response, active }: Props) {
  const [isOpen, setIsOpen] = useState(false)

  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className={`accordion-item ${active ? '' : 'hidden'}`}>
      <div
        className={`accordion-header ${isOpen ? 'open' : ''}`}
        onClick={toggleAccordion}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            toggleAccordion()
          }
        }}
      >
        <button className="accordion-question">{question}</button>
        <div className={`accordion-icon ${isOpen ? 'rotate' : ''}`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.53022 18.5303L8.46956 17.4696L13.9392 11.9999L8.46956 6.53027L9.53022 5.46961L16.0605 11.9999L9.53022 18.5303Z"
              fill="#101010"
            />
          </svg>
        </div>
      </div>

      <div className={`accordion-panel ${isOpen ? 'open' : ''}`}>
        <div
          className="accordion-response"
          dangerouslySetInnerHTML={{ __html: response }}
        />
      </div>
    </div>
  )
}
